import { StakingWidgetComponent } from "@modules/staking/components/widget/staking-widget-empty/staking-widget.component";
import { StakingWidgetHandlerComponent } from "@modules/staking/components/widget/staking-widget-handler.component";
import { StakingWidgetRewardComponent } from "@modules/staking/components/widget/staking-widget-reward/staking-widget-reward.component";
import { StakingWidgetSoldOutComponent } from "@modules/staking/components/widget/staking-widget-sold-out/staking-widget-sold-out.component";
import { StakingRewardActionsComponent } from "@modules/staking/components/widget/staking-widget-reward/staking-reward-actions/staking-reward-actions.component";
import { NgModule } from "@angular/core";
import { StakingUtlityModule } from "@modules/staking/tests/staking-utlity.module";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { BpBadgeModule } from "@modules/shared/bp-badge/bp-badge.module";

const components = [
	StakingWidgetComponent,
	StakingWidgetHandlerComponent,
	StakingWidgetRewardComponent,
	StakingWidgetSoldOutComponent,
	StakingRewardActionsComponent
];

@NgModule({
	imports: [CommonModule, CoreModule, StakingUtlityModule, BpBadgeModule],
	declarations: [...components],
	exports: [...components]
})
export class StakingWidgetsModule {}
